import AvatarDecoration from "@/components/views/avatar-decoration/AvatarDecoration";
import { useSession } from "next-auth/react";
import localImageLoader from "@/lib/local-image-loader";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";

function WelcomeCard({ user }: any) {
  const { t } = useTranslation();
  const { status } = useSession();

  const getText = () => {
    switch (status) {
      case "authenticated":
        return `${user?.firstname} ${user?.lastname}`;
      case "unauthenticated":
        return t("sidebar-login-register-button");
    }
  };

  return (
    <div className="flex gap-4 p-2 bg-stone-50 rounded-3xl">
      <div className="flex justify-center items-center w-12 h-12 rounded-2xl">
        <AvatarDecoration>
          <S3Image
            loader={localImageLoader}
            src="/placeholders/avatar.webp"
            alt={t("sidebar-user-avatar-alt")}
            height={48}
            width={48}
            sizes="48px"
            className="w-12 h-12 rounded-2xl"
          />
        </AvatarDecoration>
      </div>

      <div className="flex flex-col">
        <span className="text-gray-400 text-sm font-bold">Hoşgeldin</span>
        <span className="text-slate-800 text-xl font-bold">{getText()}</span>
      </div>
    </div>
  );
}

export default WelcomeCard;
